import { z } from 'zod';

/**
 * Zod schemas for runtime validation
 *
 * These schemas provide both runtime validation and type inference,
 * eliminating the need for type assertions throughout the codebase.
 */

// Account type enums
export const accountTypeSchema = z.enum(['Utility', 'Real Estate']);
export const realEstateAccountTypeSchema = z.enum(['CMFI', 'MHP']);

// Customer Onboarding Schemas
export const createCustomerOnboardingRequestSchema = z.object({
  waterscopeAccountId: z.string().min(1, 'WaterScape Account ID is required'),
  metronId: z
    .string()
    .regex(/^[0-9]{10}$/, 'Metron ID must be a 10-digit number'),
  accountType: accountTypeSchema,
  realEstateAccountType: realEstateAccountTypeSchema.optional(),
  salesforceId: z.string().optional(),
});

export const customerOnboardingQueueEntrySchema = z.object({
  id: z.number(),
  waterscopeAccountId: z.string(),
  metronId: z.string(),
  accountType: accountTypeSchema,
  realEstateAccountType: realEstateAccountTypeSchema.optional(),
  salesforceId: z.string().optional(),
  createdAt: z.string(),
});

// Export types inferred from schemas
export type AccountType = z.infer<typeof accountTypeSchema>;
export type RealEstateAccountType = z.infer<typeof realEstateAccountTypeSchema>;
export type CreateCustomerOnboardingRequest = z.infer<
  typeof createCustomerOnboardingRequestSchema
>;
export type CustomerOnboardingQueueEntry = z.infer<
  typeof customerOnboardingQueueEntrySchema
>;
